import { render, staticRenderFns } from "./configPrintForm.vue?vue&type=template&id=068143b3&scoped=true"
import script from "./configPrintForm.vue?vue&type=script&lang=js"
export * from "./configPrintForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068143b3",
  null
  
)

export default component.exports